import moment from 'moment';

// 时间格式
export const timeFormatType = {
  date_no_year: 'MM-DD',
  date: 'YYYY-MM-DD',
  month: 'YYYY-MM',
  time: 'YYYY-MM-DD HH:mm:ss',
  ch_date_no_year: 'MM月DD日',
  ch_date: 'YYYY年MM月DD日',
  date_no_split: 'YYYYMMDD',
  time_xg: 'YYYY/MM/DD HH:mm',
  month_no_split: 'YYYYMM',
  date_xg: 'YYYY/MM/DD',
  date_point: 'YYYY.MM.DD',
};

// 获取指定格式的时间
export function renderDate(time, type) {
  return time ? moment(time).format(type || timeFormatType.time) : '--';
}

// 获取指定格式的时间区间
export function renderDateRange(times, type) {
  return `${renderDate(times[0], type)} ~ ${renderDate(times[1], type)}`;
}

// 区分秒级和毫秒级时间戳来格式化
export function renderDateFromTimestamp(timestamp, type) {
  return renderDate((timestamp + '').length === 10 ? timestamp * 1000 : timestamp, type);
}

// 获取当前日期整月的时间跨度
export const getWholeMonthRange = (date) => {
  return [moment(date).startOf('month'), moment(date).endOf('month')];
};

// 获取时间区间，不直接用object是因为这里定义object之后，获取key值就不会获取到实时的时间区间
export const dateRange = {
  '2H': [moment().subtract(2, 'hours'), moment()],
  '1天': [moment().startOf('day'), moment().endOf('day')],
  '3天': [moment().subtract(2, 'day').startOf('day'), moment().endOf('day')],
  '7天': [moment().subtract(6, 'day').startOf('day'), moment().endOf('day')],
  '30天': [moment().subtract(29, 'day').startOf('day'), moment().endOf('day')],
  '90天': [moment().subtract(89, 'day').startOf('day'), moment().endOf('day')],
  昨天: [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
  当日: [moment().startOf('day'), moment().endOf('day')],
  上周: [
    moment().subtract(1, 'week').startOf('week').startOf('day'),
    moment().subtract(1, 'week').endOf('week').endOf('day'),
  ],
  本周: [moment().startOf('week').startOf('day'), moment().endOf('day')],
  一周: [moment().subtract(1, 'week').startOf('day'), moment().endOf('day')],
  上月: [
    moment().subtract(1, 'month').startOf('month').startOf('day'),
    moment().subtract(1, 'month').endOf('month').endOf('day'),
  ],
  上上月: [
    moment().subtract(2, 'month').startOf('month').startOf('day'),
    moment().subtract(2, 'month').endOf('month').endOf('day'),
  ],
  本月: [moment().startOf('month').startOf('day'), moment().endOf('day')],
  一月: [moment().subtract(1, 'month').startOf('day'), moment().endOf('day')],
  三月: [moment().subtract(3, 'month').startOf('day'), moment().endOf('day')],
  本季: [moment().startOf('quarter').startOf('day'), moment().endOf('day')],
  本年: [moment().startOf('year').startOf('day'), moment().endOf('day')],
  一年: [moment().subtract(12, 'month').startOf('day'), moment().endOf('day')],
  前3月: [
    moment().subtract(3, 'month').startOf('month').startOf('day'),
    moment().subtract(1, 'month').endOf('month').endOf('day'),
  ],
  前6月: [
    moment().subtract(6, 'month').startOf('month').startOf('day'),
    moment().subtract(1, 'month').endOf('month').endOf('day'),
  ],
  后7天: [moment().add(1, 'day').startOf('day'), moment().add(7, 'days').endOf('day')],
};

export const getDateRange = (dateKey) => {
  return dateRange[dateKey];
};

/**
 * 获取相对于当前时间的表现形式
 */
export function timeFromNow(time) {
  const format = 'YYYY/MM/DD HH:mm';
  const formatDate = 'YYYY/MM/DD';
  const formatTime = 'HH:mm:ss';
  let timeStr = moment(time).format(format);
  if (moment(time).format(formatDate) === moment().format(formatDate)) {
    let fromNowStr = moment(time).fromNow(true);
    if (fromNowStr.indexOf('小时') > 0 && parseInt(fromNowStr) > 5) {
      timeStr = '今天 ' + moment(time).format(formatTime);
    } else {
      if (fromNowStr.indexOf('seconds') > -1) {
        fromNowStr = '几秒';
      } else if (fromNowStr.indexOf('minutes') > -1) {
        fromNowStr = fromNowStr.replace('minutes', '分钟');
      } else if (fromNowStr.indexOf('hours') > -1) {
        fromNowStr = fromNowStr.replace('hours', '小时');
      }
      timeStr = fromNowStr + '前';
    }
  }
  return timeStr;
}

// 时间段处理，开始时间取0点，结束时间取23:59:59
export const getRangeDatesOfDate = (dates) => {
  if (dates && dates.length === 2) {
    return [moment(dates[0]).startOf('day'), moment(dates[1]).endOf('day')];
  }
  return dates;
};

// 获取时长
export const getDateDuration = (diss) => {
  // 单位：秒
  if (!diss) return '00:00:00';
  const hour = Math.floor(diss / (60 * 60));
  const rest = diss % (60 * 60);
  const minute = Math.floor(rest / 60);
  const second = rest % 60;
  const _format = (time) => (time < 10 ? `0${time}` : time);
  return `${_format(hour)}:${_format(minute)}:${_format(second)}`;
};

const timeZoneList = [
  {
    ZoneKey: 'UTC-11',
    Zone: 'UTC-11:00',
    Area: 'American Samoa, Midway Islands, Niue',
    Offset: -11,
  },
  {
    ZoneKey: 'UTC-10',
    Zone: 'UTC-10:00',
    Area: 'Honolulu, Papeete, Rarotonga',
    Offset: -10,
  },
  {
    ZoneKey: 'UTC-9',
    Zone: 'UTC-9:00',
    Area: 'Anchorage, Gambier Islands',
    Offset: -9,
  },
  {
    ZoneKey: 'UTC-8',
    Zone: 'UTC-8:00',
    Area: 'Los Angeles, Vancouver',
    Offset: -8,
  },
  {
    ZoneKey: 'UTC-7',
    Zone: 'UTC-7:00',
    Area: 'Denver, Phoenix',
    Offset: -7,
  },
  {
    ZoneKey: 'UTC-6',
    Zone: 'UTC-6:00',
    Area: 'Chicago, Mexico City',
    Offset: -6,
  },
  {
    ZoneKey: 'UTC-5',
    Zone: 'UTC-5:00',
    Area: 'New York, Toronto',
    Offset: -5,
  },
  {
    ZoneKey: 'UTC-4',
    Zone: 'UTC-4:00',
    Area: 'San Juan, Caracas',
    Offset: -4,
  },
  {
    ZoneKey: 'UTC-3',
    Zone: 'UTC-3:00',
    Area: 'Buenos Aires, Brasília, Montevideo',
    Offset: -3,
  },
  {
    ZoneKey: 'UTC-2',
    Zone: 'UTC-2:00',
    Area: 'Stanley, South Georgia and the South Sandwich Islands',
    Offset: -2,
  },
  {
    ZoneKey: 'UTC-1',
    Zone: 'UTC-1:00',
    Area: 'Azores, Praia',
    Offset: -1,
  },
  {
    ZoneKey: 'UTC+0',
    Zone: 'UTC+0:00',
    Area: 'London, Lisbon',
    Offset: 0,
  },
  {
    ZoneKey: 'UTC+1',
    Zone: 'UTC+1:00',
    Area: 'Paris, Berlin',
    Offset: 1,
  },
  {
    ZoneKey: 'UTC+2',
    Zone: 'UTC+2:00',
    Area: 'Athens, Istanbul',
    Offset: 2,
  },
  {
    ZoneKey: 'UTC+3',
    Zone: 'UTC+3:00',
    Area: 'Moscow, Saint Petersburg, Kuwait',
    Offset: 3,
  },
  {
    ZoneKey: 'UTC+4',
    Zone: 'UTC+4:00',
    Area: 'Abu Dhabi, Muscat, Baku',
    Offset: 4,
  },
  {
    ZoneKey: 'UTC+5',
    Zone: 'UTC+5:00',
    Area: 'Islamabad, Tashkent, Yekaterinburg',
    Offset: 5,
  },
  {
    ZoneKey: 'UTC+6',
    Zone: 'UTC+6:00',
    Area: 'Almaty, Dhaka, Astana',
    Offset: 6,
  },
  {
    ZoneKey: 'UTC+7',
    Zone: 'UTC+7:00',
    Area: 'Bangkok, Hanoi, Jakarta',
    Offset: 7,
  },
  {
    ZoneKey: 'UTC+8',
    Zone: 'UTC+8:00',
    Area: 'Beijing, Singapore, Taipei',
    Offset: 8,
  },
  {
    ZoneKey: 'UTC+9',
    Zone: 'UTC+9:00',
    Area: 'Tokyo, Seoul, Yakutsk',
    Offset: 9,
  },
  {
    ZoneKey: 'UTC+10',
    Zone: 'UTC+10:00',
    Area: 'Sydney, Guam, Vladivostok',
    Offset: 10,
  },
  {
    ZoneKey: 'UTC+11',
    Zone: 'UTC+11:00',
    Area: "Honiara, Nuku'alofa",
    Offset: 11,
  },
  {
    ZoneKey: 'UTC+12',
    Zone: 'UTC+12:00',
    Area: 'Wellington, Fiji, Majuro',
    Offset: 12,
  },
];

export const timeFormat = {
  range: 'YYYY-MM-DD HH:mm',
  date: 'YYYY-MM-DD',
  time: 'YYYY-MM-DD HH:mm:ss',
  hours: 'YYYY-MM-DD HH:mm:ss',
};

const getOffsetByUTCZone = (UTCZoneString, timeZoneList, defaultOffset) => {
  const existTimezone = timeZoneList.find((time) => time.ZoneKey === UTCZoneString);

  return existTimezone ? existTimezone.Offset : defaultOffset;
};

// 时间戳格式化为给定时区的时间
export const showWithTimeZone = (timestamp, UTCZoneString) => {
  const emptyResult = {
    format: '-',
    formatWithNoUTC: '-',
  };

  const timeZoneOffset = getOffsetByUTCZone(UTCZoneString, timeZoneList, 8);

  if (!timestamp) {
    return emptyResult;
  }

  if (typeof timeZoneOffset === 'number') {
    const date = new Date();
    const offsetHours = -(date.getTimezoneOffset() / 60);

    // 给定时区与浏览器本地时区的差异
    const formatTimestamp = (timestamp + '').length > 10 ? timestamp : timestamp * 1000;
    const offset = timeZoneOffset - offsetHours;
    const result = moment(formatTimestamp).add(offset, 'hour');

    return {
      format: `(UTC${(timeZoneOffset >= 0 ? '+' : '') + timeZoneOffset}) ${result.format(timeFormat.hours)}`,
      formatWithNoUTC: result.format(timeFormat.hours),
    };
  }

  return emptyResult;
};
